package com.parmartechnologies.core.feature.inventory.tag.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * Tag - A data model representing a tag entity in the inventory management system.
 * 
 * Tags are used to categorize and organize inventory items. They can be associated
 * with products, stores, or businesses to provide flexible categorization and filtering.
 * 
 * This class is serializable and uses custom serial names for MongoDB compatibility.
 */
@Serializable
data class Tag @OptIn(ExperimentalTime::class) constructor(
    // Numeric ID for the tag, defaults to current epoch seconds
    @SerialName("tag_id") var TagId: Long = Clock.System.now().epochSeconds,
    
    // ID of the user who created/owns this tag
    @SerialName("user_id") var UserID: String = "",
    
    // ID of the business this tag belongs to
    @SerialName("business_id") var BusinessID: String = "",
    
    // ID of the store this tag is associated with
    @SerialName("store_id") var storeId: String = "",
    
    // Soft delete flag (0 = active, 1 = deleted)
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    
    // Human-readable name of the tag
    @SerialName("name") var Name: String = "",
    
    // Type category of the tag (e.g., "product", "category", "custom")
    @SerialName("type") var Type: String = "",
    
    // Value or code associated with the tag
    @SerialName("value") var Value: String = "",
    
    // Detailed description of what this tag represents
    @SerialName("description") var Description: String = "",

): BaseDataClass()